const WMICTopics = {
    // Page navigation
    ROUTE_CHANGED: 'WMIC_TOPICS.WMIC_ROUTE_CHANGED',
    QUOTE_PAGE_LOADED: 'WMIC_TOPICS.WMIC_QUOTE_PAGE_LOADED',
    PURCHASE_COMPLETED: 'WMIC_TOPICS.WMIC_PURCHASE_COMPLETED',
    //FORM_FIELD_INTERACTION: 'WMIC_TOPICS.WMIC_FORM_FIELD_INTERACTION',
    FORM_ERROR: 'WMIC_TOPICS.WMIC_FORM_ERROR',
    CTA_CLICK: 'WMIC_TOPICS.WMIC_CTA_CLICK',
    //NAVIGATION_CLICK: 'WMIC_TOPICS.WMIC_NAVIGATION_CLICK'
    MODAL_INTERACTION: 'WMIC_TOPICS.WMIC_MODAL_INTERACTION'
};

export default WMICTopics;